<template>
  <div class="topbar">
    <header class="main-header " id="header">
      <nav class="navbar navbar-expand-md bg-dark navbar-dark">
        <!-- Brand -->
        <div class="navbar-placeholder">Genius Lighting</div>

        <div class="sidebar-menu-btn" @click="controlSidebar">
          <div class="hamburger-lines">
            <span class="line line1"></span>
            <span class="line line2"></span>
            <span class="line line3"></span>
          </div>
        </div>

        <!-- Navbar links -->
        <div class="collapse navbar-collapse" id="collapsibleNavbar">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a v-if="user" class="nav-link" href="#">{{ user.employee_name }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="logout">Logout</a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  </div>
</template>


<script>
import { mapState, mapActions } from 'vuex';
import Common from '@/lib/common';

export default {
  name: 'Topbar',
  data() {
    return {
      user: null,
    }
  },
  mounted() {
    this.getUser();
  },
  methods: {
    controlSidebar() {
      const body = document.querySelector('body');
      const sidebar = document.querySelector('.sidemenu-wrapper');
      const mainContent = document.querySelector('.main-content');
      if (!this.displaySidebar) {
        this.showSidebar();
        body.classList.add('display-sidemenu');
        sidebar.classList.add('display-mobile');
        mainContent.classList.add('openmenu');
      } else {
        this.hiddenSidebar();
        body.classList.remove('display-sidemenu');
        sidebar.classList.remove('display-mobile');
        mainContent.classList.remove('openmenu');
      }
    },
    async getUser() {
      const currentUserId = window.localStorage.getItem('userId');
      const token = window.localStorage.getItem('loginToken');
      const loginInfo = {
        userId: currentUserId,
        token,
      };
      const user = await Common.getUserInfo(this.apiUrl, currentUserId, loginInfo);
      this.setUser(user);
      this.user = user;
    },
    async logout() {
      await this.startLogout();
      window.localStorage.clear();
      this.removeUser();
      this.$router.push({ name: 'Login' });
    },
    ...mapActions(['startLogout', 'setUser', 'removeUser', 'showSidebar', 'hiddenSidebar']),
  },
  computed: mapState({
    displaySidebar: state => state.displaySidebar,
    apiUrl: state => state.apiUrl,
  }),
}
</script>

<style lang="scss">
.topbar {
  position: sticky;
  top: 0;
  z-index: 50;
}

.logo {
  width: 40px;
}

.navbar-placeholder {
  flex: 1;
  color: white;
}

#collapsibleNavbar {
  justify-content: flex-end;
}

.sidebar-menu-btn {
  margin-left: 10px;
  position: relative;
  z-index: 999;

  &:hover {
    cursor: pointer;
  }
}

.hamburger-lines {
  height: 20px;
  width: 26px;
  display: none;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (max-width: 992px) {
    display: flex;
  }
}

.hamburger-lines .line {
  display: block;
  height: 3px;
  width: 100%;
  border-radius: 10px;
  background: white;
}

.hamburger-lines .line1 {
  transform-origin: 0% 0%;
  transition: transform 0.4s ease-in-out;
}

.hamburger-lines .line2 {
  transition: transform 0.2s ease-in-out;
}

.hamburger-lines .line3 {
  transform-origin: 0% 100%;
  transition: transform 0.4s ease-in-out;
}

</style>
